<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.go(-1)"></div>
      <div class="big_tit">{{ $t('invest.recharge') }}</div>
    </div>
    <!--    <div class="balance" v-if="eye == 1">-->
    <!--      <p>-->
    <!--        {{ $t('utils.moneyMark') }}{{ balance }}-->
    <!--      </p>-->
    <!--      <p>-->
    <!--        {{ $t('invest.availableBalance') }}-->
    <!--        <van-icon name="eye-o" @click="eye = 0"/>-->
    <!--      </p>-->
    <!--    </div>-->
    <!--    <div class="balance" v-if="eye == 0">-->
    <!--      <p>-->
    <!--        ******-->
    <!--      </p>-->
    <!--      <p>-->
    <!--        {{ $t('invest.availableBalance') }}-->
    <!--        <van-icon name="closed-eye" @click="eye = 1"/>-->
    <!--      </p>-->
    <!--    </div>-->
    <form class="form">
      <div
          v-if=" data.channel == 9 || data.channel == 13 || data.channel == 14 || data.channel == 15 || data.channel == 16">
        <div class="recharge_wrap">
          <p>{{ $t('addbank.accountName') }}</p>
          <div class="flex_center">
            <span></span>
            <input v-model.trim="data.name" type="text" class="inp"
                   :placeholder="$t('addbank.insertUserName')">
            <span></span>
          </div>
        </div>
        <div class="recharge_wrap">
          <p>{{ $t('login.phone') }}</p>
          <div class="flex_center">
            <span></span>
            <input v-model.trim="data.phone" type="number" class="inp"
                   :placeholder="$t('login.phoneNumber')">
            <span></span>
          </div>
        </div>
      </div>
      <!--<div v-if="data.channel == 10|| data.channel == 16">
        <div class="recharge_wrap">
          <p>{{ $t('login.email') }}</p>
          <div class="flex_center">
            <span></span>
            <input v-model.trim="data.email" type="text" class="inp"
                   :placeholder="$t('login.emailAddress')">
            <span></span>
          </div>
        </div>
      </div>-->
      <div v-if="data.channel == 6">
        <div class="recharge_wrap">
          <p>{{ $t('login.phone') }}</p>
          <div class="flex_center">
            <span></span>
            <input v-model.trim="data.phone" type="number" class="inp"
                   :placeholder="$t('login.phoneNumber')">
            <span></span>
          </div>
        </div>
      </div>
      <!-- 支付金额 -->
      <div class="recharge_wrap padding-10">
        <p>{{ $t('invest.rechargeAmount') }}</p>
        <div class="flex_center">
          <span>{{ $t('currency') }}</span>
          <input v-model.trim="data.money" type="number" step="0.01" class="inp"
                 :placeholder="$t('invest.rechargeAmount')" @input="changeAmount" readOnly="true">
          <span>{{ actualAmount }}</span>
        </div>
      </div>
      <!-- 抵扣金额 -->
      <div v-if="data.discountAmount" class="flex flex-align flex-between padding-10">
        <div class="color-main">{{ $t('Discount amount') }}</div>
       <div class="color-main">-{{ $t('currency') }}{{ Number(data.discountAmount).toFixed(2) }}</div>
      </div>
      <!-- 实际支付金额 -->
      <div v-if="data.discountAmount" class="flex flex-align flex-between padding-10 mt-20">
        <div class="color-black font-14 font-bold">{{ $t('Actual payment amount') }}</div>
        <div class="color-blackmain font-14 font-bold">{{ $t('currency') }}{{ Number(data.money - data.discountAmount).toFixed(2) }}</div>
      </div>
      <div class="recharge_fs">
        <div class="tit">
          {{ $t('invest.paymentMethod') }}
        </div>
        <div v-for="(v, k) in config.payment" :key="k" class="item" @click="choose_type(k + 1, v)">
          <div class="check" :class="k + 1 == data.choose ? 'checked' : ''"/>
<!--          <div class="re_icon"><img :src="v.logo"/></div>-->
          <div class="re_name">
            {{ v.name }}
          </div>
        </div>
      </div>
<!--      <div class="choose_bank" @click="showBank = true">-->
<!--        <div>-->
<!--          <span>{{$t('cash.bank')}}</span>-->
<!--        </div>-->
<!--        <div>-->
<!--          <span>{{bankName}}</span>-->
<!--          <van-icon name="arrow" color="#999"/>-->
<!--        </div>-->
<!--      </div>-->

    </form>
    <div class="hint">
      <div class="desc" v-html="rule.content"></div>
    </div>
    <div class="basic_btn sbtn" @click="submit">
      {{ $t('invest.next') }}
    </div>

    <van-action-sheet
      v-model="showBank"
      :actions="bankList"
      cancel-text=""
      :description="this.$t('cash.chooseBank')"
      close-on-click-action
      @select="onBankSelect"
    />
  </div>
</template>

<script>
  import Vue from 'vue';
  import {
    CountDown,
    Checkbox,
    RadioGroup,
    Icon,
    Radio
  } from 'vant';
  import {
    jsBridge
  } from '../../utils/jsbridge-mini.js';
  import Fetch from '../../utils/fetch'
  import Api from "../../interface/index";

  Vue.use(RadioGroup);
  Vue.use(Radio);
  Vue.use(CountDown).use(Checkbox).use(Icon);

  export default {
    name: "invest",
    data() {
      return {
        time: 0,
        eye: 1,
        balance: 0.00,
        data: {
          choose: '',
          channel: '',
          name: '',
          phone: '',
          money: '',
          id: '',
          goodId: '',
          upid: '',
          bankCode: '',
          contract_image: ''
        },
        payment: [],
        config: {},
        actualAmount: '',
        goodInfo: {},
        showBank: false,
        bankName: '',
        bankCode: '',
        bankList: [
          {code:'GCASH',name:'GCASH'},
          {code:'PMP',name:'PayMaya Philippines'},
        ],
        rule: {}, // 规则
      };
    },
    created() {
      this.$parent.footer('user', false);
    },
    mounted() {
      this.start();
    },
    methods: {
      // 选择银行
      onBankSelect(item){
        this.bankName = item.name
        this.bankCode = item.code
      },
      start() {
        this.data.contract_image = localStorage.getItem('contract_image');
        this.data.goodId = this.$router.history.current.params.id; // 升级后设备id
        this.data.upid = this.$router.history.current.params.upid; // 升级前设备id

        // 获取商品信息
        Fetch('/index/item_detail', {
          id: this.data.goodId
        }).then(res => {
          this.goodInfo = res.data;
          this.data.money = this.goodInfo.min
          this.data.discountAmount = this.goodInfo.discount_amount;
        })

        Fetch('/user/recharge', {
          ...this.data
        }).then((r) => {
          this.rule = r.data.rule;
          this.balance = r.data.money;
          this.config = r.data;
          this.config.min_recharge = parseInt(this.config.min_recharge);
          this.choose_type(1, r.data.payment[0]);
        });
      },
      checkLimit() {

        const key = 'invest_button';
        const ttl = 60;
        let now = Date.parse(new Date()) / 1000;
        let val = localStorage.getItem(key);
        if (!val) {
          val = JSON.stringify({
            'ttl': now + ttl
          })
          localStorage.setItem(key, val)
          return true;
        } else {
          val = JSON.parse(val);
          if (val['ttl'] > now) {
            return false;
          } else {
            val = JSON.stringify({
              'ttl': now + ttl
            })
            localStorage.setItem(key, val)
            return true;
          }
        }
      },
      choose_type(k, payment) {
        this.data.choose = k;
        this.data.channel = payment.type;
        this.data.id = payment.id;
        this.payment = payment;
        this.changeAmount();
      },
      submit() {
        if (!this.data.money || Number(this.data.money) < this.payment.min_recharge) {
          this.$toast(this.$t('invest.rechargeAmountLow') + this.$t('currency') + this.payment.min_recharge + this.$t('invest.rechargeAmountLow1'));
          return false;
        }
        if (!this.data.channel) {
          this.$toast(this.$t('invest.paymentMethodEmpty'));
          return false;
        }

        this.submitPay();
      },
      // 提交支付
      submitPay() {
        // 银行卡转账
        if(this.payment.classify == 2 ) {
          Fetch("/user/recharge_type", {
            ...this.data
          }).then((r) => {
            if (r.code == 1) {
              this.$router.replace({
                path: '/invest/bank',
                query: {
                  orderId: r.orderId,
                  money: this.data.money,
                }
              });
              return;
            }else{
              this.$toast(r.msg);
            }
          });

        } else {
          if (this.data.channel == 5) {
            Fetch('/user/cspay', {
              ...this.data
            }).then((r) => {
              if (r.code == 1) {
                window.location = r.url
                return;
              }else{
                this.$toast(r.msg);
              }
            });
          } else if (this.data.channel == 18) {
            Fetch('/user/uzpay', {
              ...this.data
            }).then((r) => {
              if (r.code == 1) {
                localStorage.setItem('contract_image', '');
                window.location = r.url
                return;
              }else{
                this.$toast(r.msg);
              }
            });
          } else {
            this.$router.replace({
              path: '/invest/' + this.data.channel,
              query: {
                money: this.data.money,
              }
            });
          }
        }
      },
      changeAmount() {
        var num = 2;
        if (this.payment.type) {
          if (this.payment.type == 1) {
            if (this.payment.rate > 10000) {
              num = 8;
            } else if (this.payment.rate > 1000) {
              num = 6;
            } else if (this.payment.rate > 10) {
              num = 4;
            }
            this.actualAmount = "≈" + (this.data.money / this.payment.rate).toFixed(num) + this.payment.mark;
          } else {
            this.actualAmount = "≈" + this.payment.mark + (this.data.money / this.payment.rate).toFixed(num);
          }
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  #app {
    position: relative !important;
  }

  .red_top_bg {
    /*height: 126px;*/
    background: #76b900;
    position: fixed;
  }

  .top_right {
    position: absolute;
    font-size: 13px;
    line-height: 18px;
    color: #FFFFFF;
    top: 36px;
    right: 14px;
  }

  .balance {
    width: 96%;
    margin-left: 2%;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    padding: 20px 0px;
    position: absolute;
    top: 78px;
    text-align: center;

    p:nth-child(1) {
      font-size: 26px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    p:nth-child(2) {
      color: #999;
      font-weight: bold;
    }
  }

  .recharge_fs {
    margin-top: 10px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    padding: 0 16px;
  }

  .recharge_box {
    width: 100%;
    height: 48px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    margin-top: 12px;
    padding: 16px 11px;

    input {
      height: 18px;
      width: 100%;
      line-height: 18px;
      font-size: 14px;
    }
  }

  .form {
    width: 96%;
    margin-left: 2%;
    margin-top: 50px;

    .recharge_wrap {
      width: 100%;
      background: #ffffff;
      border-radius: 6px;
      padding: 16px 20px;
      margin-top: 10px;

      input {
        height: 18px;
        width: 60%;
        line-height: 18px;
        font-size: 14px;
      }

      div {
        span:nth-child(1) {
          font-size: 18px;
          margin-right: 10px;
          font-weight: bold;
        }

        span:nth-child(3) {
          font-size: 14px;
          width: 40%;
          color: #999;
          text-align: right;
        }
      }

      p:nth-child(1) {
        font-size: 16px;
        font-weight: bold;
        color: #999;
        margin-bottom: 20px;
      }

      p:nth-child(3) {
        color: #999;
        margin-top: 20px;
      }

    }

    .tit {
      height: 54px;
      border-bottom: 1px solid #ECECEC;
      font-size: 16px;
      color: #999;
      font-weight: bold;
      line-height: 54px;
    }

    .item {
      height: 57px;
      border-bottom: 1px solid #ECECEC;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      &:last-child {
        border-bottom: none;
      }

      .check {
        width: 16px;
        height: 16px;
        margin-left: 4px;
        background: url(../images/user/c2.png) no-repeat center center;
        background-size: 100% 100%;

        &.checked {
          background: url(../images/user/c1.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }

      .re_icon {
        width: 20px;
        height: 20px;
        margin-left: 11px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .re_name {
        font-size: 16px;
        line-height: 22px;
        color: rgba(0, 0, 0, .8);
        margin-left: 4px;
      }

      .wx {
        background: url(../images/user/recharge3.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .alipay {
        background: url(../images/user/recharge2.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .usdt {
        background: url(../images/user/recharge1.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .alipay_app {
        background: url(../images/user/recharge2.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .bank {
        background: url(../images/user/recharge4.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }

  .sbtn {
    margin: 75px auto 20px auto;
  }
  .choose_bank {
    width: 100%;
    background: #FFFFFF;
    border-radius: 5px;
    padding:20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    div:nth-child(1){
      width: 32%;
      font-size: 16px;
      font-weight: bold;
      color: #999;
    }
    div:nth-child(2){
      width: 68%;
      text-align: right;
      font-size: 16px;
      font-weight: bold;
      color: #999;
    }
  }

  .hint {
    margin: 20px;
    color: red;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    padding: 15px 13px;
    border: 1px solid #76b900;
    border-radius: 5px;
  }

</style>
